import store from "@/store";
import {onBeforeMount} from "@vue/composition-api";
import moment from 'moment';
export class TableActionClass {
    public _data : any;
    public constructor(data:any) {
        this._data = data;
    }
    get getData(): any {
        return this._data;
    }
    /*set setData(data:any) {
        this._data = data;
    }*/
    // run api
    async  execute(fnName:string, ctx:any,/*, args*/){
        this._data.params.isLoading = true;
        let args = Array.prototype.slice.call(arguments, 2);
        let result = await ctx[fnName].apply(ctx, args);;
        if(Array.isArray(result.data)){
            this._data.list = result.data;  // 목록
            this._data.count = result.count; // 총계
            this._data.params.mode = '';
            this._data.row = {};
            this._data.params.mode = 'list';
        }else{
            this._data.list = []
            this._data.row = result.data;
            this._data.params.mode = 'detail';
        }
        this._data.params.isLoading = false;
        return result;
    }

    // 정렬
    sort(_search:any,field:any){
        this._data.params.page = 1;
        this._data.params.sort = field;
        this._data.params.direction = this._data.params.direction=='asc'?'desc':'asc';
        _search()
    }
    // 신규
    newItem() {
        this._data.params.mode = 'detail';
    }
    // 초기화
    clear() {
        this._data.params = {}
        this._data.params.page = 1;
        this._data.params.mode = 'list';
        this._data.params.schType='';
        this._data.params.schText='';
        this._data.count = 0;
        this._data.list  = [];
        this._data.row = {};
    }
    // 다음
    next(_search:any){
        this._data.params.page>=this.lastPage()? this.lastPage():this._data.params.page++;
        _search()
    }
    // 이전
    prev(_search:any){
        if(this._data.params.page>1)this._data.params.page--;
        _search()
    }
    // 처음으로
    first(_search:any){
        this._data.params.page = 1;
        _search()
    }
    // 끝으로
    last(_search:any,){
        this._data.params.page = this.lastPage();
        _search()
    }
    lastPage(){
        let _count = this._data.count;
        let _limit = this._data.params.limit?this._data.params.limit:10;
        let _max: number = Math.ceil(_count/_limit);
        return _max
    }

    dateFormatter(date:any) {
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        if(month < 10) month = '0' + month;
        var day = date.getDate();
        if(day < 10) day = '0' + day;
        let retDate = String(year)+'-'+String(month)+'-'+day
        console.log('dateFormatter:',retDate);

        return retDate;
        //return moment(date).format('YYYY-MM-DD');
    }

}